import { useState, useCallback } from "react";
import { useEffectOnce } from "react-use";

import cn from "@utils/cn";
import { toastify } from "@vendors";
import { redirectTo } from "@utils";
import Button from "@elements/Button";

const classNames = cn(`
  bg-circuits
  flex
  min-h-screen
  content-center
  justify-center
`);

export default function LoginPage(props) {
  const { data, error } = props;

  useEffectOnce(() => {
    if (error) {
      toastify.error(error);
    }
  });

  const [isRedirecting, setIsRedirecting] = useState(false);

  const onClickButton = useCallback((_event) => {
    setIsRedirecting(true);

    redirectTo(data.googleAuthUrl);
  }, [data.googleAuthUrl]);

  /**************************************************************************************************/

  return (
    <main className={classNames}>
      <div className="flex flex-col items-center justify-center gap-6">
        <div className="text-center flex flex-col items-center gap-4">
          <img
            src="https://kinn-app.s3.amazonaws.com/wordmark.png"
            alt="Kinn"
            className="h-6"
          />

          <div className="select-none text-3xl md:text-4xl text-white font-medium">
            {window.appContext.kinndomKey}
          </div>
        </div>

        <Button
          className="w-fit font-medium"
          onClick={onClickButton}
          value="Sign in with Google"
          iconName={["fab", "google"]}
          isLoading={isRedirecting}
        />
      </div>
    </main>
  );
}
